import { render, staticRenderFns } from "./SchoolHomeComModal.vue?vue&type=template&id=21d34fdc&scoped=true"
import script from "./SchoolHomeComModal.vue?vue&type=script&lang=js"
export * from "./SchoolHomeComModal.vue?vue&type=script&lang=js"
import style0 from "./SchoolHomeComModal.vue?vue&type=style&index=0&id=21d34fdc&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d34fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d34fdc')) {
      api.createRecord('21d34fdc', component.options)
    } else {
      api.reload('21d34fdc', component.options)
    }
    module.hot.accept("./SchoolHomeComModal.vue?vue&type=template&id=21d34fdc&scoped=true", function () {
      api.rerender('21d34fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/SchoolHomeComModal.vue"
export default component.exports